export const rem = ({
    size,
    rootSize = 16,
    withUnit = true,
}: {
    size: number;
    rootSize?: number;
    withUnit?: boolean;
}) => {
    const remValue = size / rootSize;
    return withUnit ? `${remValue}rem` : remValue;
};
